import axios from 'axios'
import {SubscriberModel} from '../models/SubscriberModel'

const API_URL = process.env.REACT_APP_API_URL

export function getSubscriberById(id: string) {
  return axios.get<SubscriberModel>(`${API_URL}/Subscribers/${id}`)
}
